// this is the Exit component used in the intro, it has an absolute position and
// will float in the top right corner of the screen

import React from 'react';

import ExitLink from '~app/components/ExitLink';

const IntroExit = () => (
  <div className="IntroExit__layout">
    <ExitLink />
  </div>
);

export default IntroExit;


// WEBPACK FOOTER //
// ./src/pages/intro/IntroExit.js